import { useState } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import './Layout.css';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-layout">
      <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

      <div className="app-body">
        <Sidebar isOpen={sidebarOpen} />

        <div className={`app-main ${sidebarOpen ? 'shifted' : ''}`}>
          <div className="page-content">{children}</div>
        </div>
      </div>
    </div>
  );
}